<!--
 * @Author: 
 * @Date: 2022-06-28 16:22:29
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-22 15:28:37
 * @FilePath: /Cup2Supplier/Users/onepisya/Documents/GitHub/jdhl_work/Cup2Market/src/components/custom-image.vue
 * @Description: 
-->
<template>
  <div class="relative">
    <van-image v-bind="$attrs" v-on="$listeners" class="rounded-sm"/>
    <div ref="myImgText" id="custom-image-text-id" class="absolute img-text">
      <!-- pre-sale-color -->
      <!-- buyer -->
      <!-- <slot name="text"></slot> -->
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomImage",
  props: {
    /* 
      可选项
    sale-num 
    pre-sale
    */
    tag: {
      type: String,
      default: () => "sale-num",
    },
  },
  watch: {
    tag: {
      handler(newval, oldval) {
        console.log(newval, "tag newval");
        this.$nextTick(() => {
          this.updateColor(newval);
        });
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    updateColor(tag) {
      const root = this.$refs.myImgText;
      if (tag === "pre-sale") {
        root.classList.add("pre-img-text");
      } else {
        if ("pre-sale-color" in root.classList) {
          root.classList.remove("pre-img-text");
        }
      }
    },
  },
  mounted() {
    this.updateColor(this.tag);
  },
};
</script>

<style style="less" scoped>
.img-text {
  /* px-to-viewport-ignore-next */
  bottom: 9px;
  /* px-to-viewport-ignore-next */
  right: 6px;
  background: var(--sale-status-img-text-color);
  color: #fff;
  /* px-to-viewport-ignore-next */
  border-radius: 9px;
  /* width: fit-content(200px); */
  /* px-to-viewport-ignore-next */
  padding: 0 3px;
  /* px-to-viewport-ignore-next */
  height: 19px;
  /* px-to-viewport-ignore-next */
  line-height: 19px;
  /* px-to-viewport-ignore-next */
  font-size: 12px;
}
.pre-img-text {
  background: var(--pre-sale-status-img-text-color);
}
</style>
